import { configureStore } from '@reduxjs/toolkit';
import artifactTypesReducer from './slices/artifactTypeSlice';
import primeArtifactsReducer from './slices/primeArtifactSlice';
import parameterTypesReducer from './slices/parameterTypeSlice';
import artifactsReducer from './slices/ArtifactSlice';
import primeModelReducer from './slices/primeModelSlice';
import businessModelReducer from './slices/BusinessModelSlice';

// Create the store with all reducers
export const store = configureStore({
  reducer: {
    artifactTypes: artifactTypesReducer,
    primeArtifacts: primeArtifactsReducer,
    parameterTypes: parameterTypesReducer,
    artifacts: artifactsReducer,
    primeModel: primeModelReducer,
    businessModels: businessModelReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

// Export types for TypeScript
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Export store
export { store as default };

// Export specific actions from slices
export {
  fetchArtifact,
  fetchArtifacts,
  createArtifact,
  updateArtifact,
  deleteArtifact,
  fetchParameters,
  createParameter,
  updateParameter,
  deleteParameter,
  checkRootStatus,
  createRootArtifact,
  fetchRecommendedArtifacts,
  createRecommendedArtifact,
  fetchRecommendedParameters,
  createRecommendedParameter,
  createFromPrime,
  addParameter,
} from './slices/ArtifactSlice';

export {
  fetchArtifactTypes,
  createArtifactType,
  updateArtifactType,
  deleteArtifactType,
  selectArtifactTypes,
  selectSortedArtifactTypes,
  selectArtifactTypesLoading,
  selectArtifactTypesError,
} from './slices/artifactTypeSlice';

export { fetchParameterTypes } from './slices/parameterTypeSlice';

export {
  fetchPrimeArtifacts,
  fetchPrimeArtifactsHierarchy,
  fetchPrimeArtifactStates,
  fetchPrimeArtifactTransitions,
  fetchPrimeProcesses,
  createPrimeModel,
  updatePrimeModel,
  deletePrimeModel,
  createPrimeArtifactTransition,
  updatePrimeArtifactTransition,
  deletePrimeArtifactTransition,
  createPrimeProcess,
  updatePrimeProcess,
  deletePrimeProcess,
  deletePrimeArtifact,
} from './actions/primeArtifactActions';

export {
  setArtifacts,
  setLoading,
  setError,
  setSelectedArtifact,
  setModelData,
  setShowSummary,
  resetModel,
} from './slices/primeModelSlice';
